export enum ActionTypes {
  SET = "@versao/SET",
}
export interface IVersaoApp {
  api: string;
  model: string;
  service: string;
  app: string;
}
